$('.js-accordion-head').on('click', function () {
	$(this).toggleClass('accordion__head--active').next().slideToggle();
});
